/**
 *
 * MainLayout
 *
 */

import React, { memo, useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';

import { useInjectSaga } from 'utils/injectSaga';
import { useInjectReducer } from 'utils/injectReducer';
import reducer from './reducer';
import saga from './saga';

// styles
import './style.scss';

import { flushState } from './actions';
import {
  makeSelectError,
  makeSelectLoading,
  makeSelectMainLayout,
} from './selectors';

// antd component
import { Layout } from 'antd';
const { Content } = Layout;

// assets
//import CustomIcons from 'components/CustomIcons';

// pages
//import SearchBar from 'pages/SearchBar';
//import Notifications from 'pages/Notifications';
import Users from 'pages/Users';
import Classes from 'pages/Classes';
import Students from 'pages/Students';
import Courses from 'pages/Courses';
import Absence from 'pages/Absence';
import AbsenceDetail from 'pages/AbsenceDetail';
import Home from 'pages/Home';
import Plans from 'pages/Plans';
import Communications from 'pages/Communications';
import Audiences from 'pages/Audiences';
import Settings from 'pages/Settings';
import AudienceDetail from 'pages/AudienceDetail';

// test
import TestContainer from 'containers/TestContainer';

// layout components
import Preloader from 'components/Preloader';
import HeaderLayout from 'layouts/HeaderLayout';
import SideLayout from 'layouts/SideLayout';
import AccessDenied from 'layouts/AccessDenied';
import ModalOnSaveChanges from 'layouts/ModalOnSaveChanges';

// utils
import AuthRoute from 'engine/AuthRoute';
// contexts
import { withTheme } from 'engine/Contexts/Theme.context';

//import { ResetPassword } from 'pages/ResetPassword';

export function MainLayout({
  // contexts
  theme,
  // actions here
  history,
  flushState,
}) {
  useInjectReducer({ key: 'mainLayout', reducer });
  useInjectSaga({ key: 'mainLayout', saga });

  const [spinner, setSpinner] = useState(true);

  const [freshNotifications, setFreshNotifications] = useState([
    {
      _id: 1,
      title: 'Notif 1',
    },
  ]);

  /*   useEffect(() => {
    // TODO make it work without req when freshNotifications.length === 0
    if (user._id) {
      loadFreshNotificationsAction(user._id);
    }
  }, [user._id, location]); */

  /**
   * Loading data for rendering in a component
   * - work like ComponentDidUpdate
   */
  useEffect(() => {
    const preloader = setTimeout(() => setSpinner(false), 1500);

    // Anything in here is fired on component unmount.
    return () => {
      // this will clear setTimeout
      clearTimeout(preloader);
      // Clearing the state after unmounting a component
      flushState();
    };
  }, []);

  const onBellClickHandler = () => {
    if (freshNotifications.length > 0) {
      // console.log({ freshNotifications });
    }
  };

  const showOpenOnSaveModalCallback = useCallback(() => {
    theme?.onOpenOnSaveModalCallback();
  }, [theme?.isOpenModalOnSaveChanges, theme?.hasValueModalOnSaveChanges]);
  
  // render function
  return (
    <>
      {spinner && <Preloader fullWidth />}
      {!spinner && (
        <>
          <Layout className="app-main-layout">
            {/* Desctop Menu */}
            <HeaderLayout
              notifications={freshNotifications}
              notificationsAction={onBellClickHandler}
            />

            {/* Desctop SideBar Menu */}
            <SideLayout />

            <Content className={`layout-content`}>
              <AuthRoute
                path={['/', '/home']}
                component={Home}
                roles={['admin', 'teacher']}
                exact
              />

              <AuthRoute path="/test" component={TestContainer} />
              <AuthRoute
                path={['/utilisateurs', '/utilisateurs/:id']}
                component={Users}
                exact
              />
              <AuthRoute
                path={['/classes', '/classes/:id']}
                component={Classes}
                exact
              />
              <AuthRoute
                path={['/etudiants', '/etudiants/:id']}
                component={Students}
                exact
              />
              <AuthRoute
                path={['/сours', '/сours/:id']}
                component={Courses}
                exact
              />
              <AuthRoute path={'/absences'} component={Absence} exact />
              <AuthRoute
                path={'/absences/:id'}
                component={AbsenceDetail}
                exact
              />

              <AuthRoute path={'/plans'} component={Plans} exact />

              <AuthRoute
                path={[
                  '/communications',
                  '/communications/:id',
                  '/communications/:id?preview=true',
                  '/communications/nouvel',
                ]}
                roles={['admin', 'teacher']}
                component={Communications}
                exact
              />

              <AuthRoute
                path="/audiences"
                roles={['admin', 'teacher']}
                component={Audiences}
                exact
              />
              <AuthRoute
                path={['/audiences/:id', '/audiences/nouvel']}
                roles={['admin', 'teacher']}
                component={AudienceDetail}
                exact
              />
              <AuthRoute path="/settings" component={Settings} exact />

              {/* Close access for WEB version */}
              <AuthRoute
                path={['/signupparent', '/linkstudent']}
                component={AccessDenied}
                roles={['parent']}
              />
            </Content>
          </Layout>
          <ModalOnSaveChanges />
        </>
      )}
    </>
  );
}

MainLayout.propTypes = {
  dispatch: PropTypes.func.isRequired,
  flushState: PropTypes.func.isRequired,
};

const mapStateToProps = createStructuredSelector({
  loading: makeSelectLoading(),
  error: makeSelectError(),
  mainLayout: makeSelectMainLayout(),
});

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    flushState: () => dispatch(flushState()),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withConnect,
  memo,
  withRouter,
  withTheme,
)(MainLayout);
